import React, { useEffect, useState } from 'react';

import CargoInsurance from './CargoInsurance/CargoInsurance';
import CarrierInformation from './CarrierInformation/CarrierInformation';
import { Block, BorderBottom, Count, Item, Line, Tab, TabPanel, Text, Title, Wrapper } from './carrierProfile.style';
import Step from './Step/Step';
import { SuperDispatchInformation } from './SuperDispatchInformation/SuperDispatchInformation';
import USDOT from './USDOT/USDOT';
import W9 from './W9/W9';
import { getCarrierProfile, getPenguinProfile } from '../../API/carrierProfile';
import SettingsContainer from '../../layout/SettingsContainer';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Preloader from '../Preloader/Preloader';

const TAB = {
  CARRIER: 0,
  SUPER_DISPATCH: 1,
  PENGUIN: 2,
  CARGO: 3,
  W9: 4,
  USDOT: 5,
};

const CarrierProfile: React.FC = () => {
  const dispatch = useAppDispatch();
  const [tab, setTab] = useState<string>('Carrier information');
  const [tabValue, setTabValue] = useState<number>(0);

  const { data, loading } = useAppSelector((state: { carrierProfile: any }) => state.carrierProfile);

  const { data: penguinData, loading: penguinLoad } = useAppSelector(
    (state: { penguinProfile: any }) => state.penguinProfile
  );

  useEffect(() => {
    dispatch(getCarrierProfile(null));
    dispatch(getPenguinProfile(null));
  }, []);

  if (loading || penguinLoad) return <Preloader />;

  return (
    <>
      <SettingsContainer>
        <Wrapper>
          <Title>Profile</Title>
          <Block>
            <TabPanel variant="scrollable" value={tabValue} scrollButtons allowScrollButtonsMobile>
              <Tab
                style={{
                  color: tab === 'Carrier information' ? '#1267CF' : '#616172',
                }}
                onClick={() => {
                  setTab('Carrier information');
                  setTabValue(TAB.CARRIER);
                }}
              >
                Carrier information{' '}
                <Count
                  style={{
                    color:
                      tab === 'Carrier information' ? '#0E71EB' : data && data?.carrier_name ? '#0BAA1B' : '#616172',
                    backgroundColor:
                      tab === 'Carrier information'
                        ? '#B0DCFF'
                        : data && data?.carrier_name
                          ? 'rgba(11, 170, 27, 0.15)'
                          : '#e9eaf8',
                  }}
                >
                  {data && data?.carrier_name ? 'Done' : 'Pending'}
                </Count>
              </Tab>

              <Tab
                style={{
                  color: tab === 'SuperDispatch Information' ? '#1267CF' : '#616172',
                }}
                onClick={() => {
                  setTab('SuperDispatch Information');
                  setTabValue(TAB.SUPER_DISPATCH);
                }}
              >
                SuperDispatch Information{' '}
                <Count
                  style={{
                    color:
                      tab === 'SuperDispatch Information'
                        ? '#0E71EB'
                        : data && data?.superdispatch_client_id
                          ? '#0BAA1B'
                          : '#616172',
                    backgroundColor:
                      tab === 'SuperDispatch Information'
                        ? '#B0DCFF'
                        : data && data?.superdispatch_client_id
                          ? 'rgba(11, 170, 27, 0.15)'
                          : '#e9eaf8',
                  }}
                >
                  {data && data?.superdispatch_client_id ? 'Done' : 'Pending'}
                </Count>
              </Tab>

              <Tab
                style={{
                  color: tab === 'Penguin information' ? '#1267CF' : '#616172',
                }}
                onClick={() => {
                  setTab('Penguin information');
                  setTabValue(TAB.PENGUIN);
                }}
              >
                P Mode Info{' '}
                <Count
                  style={{
                    color:
                      tab === 'Penguin information'
                        ? '#0E71EB'
                        : penguinData && penguinData?.carrier_name
                          ? '#0BAA1B'
                          : '#616172',
                    backgroundColor:
                      tab === 'Penguin information'
                        ? '#B0DCFF'
                        : penguinData && penguinData?.carrier_name
                          ? 'rgba(11, 170, 27, 0.15)'
                          : '#e9eaf8',
                  }}
                >
                  {penguinData && penguinData?.carrier_name ? 'Done' : 'Pending'}
                </Count>
              </Tab>

              {/*<Tab*/}
              {/*  style={{*/}
              {/*    color: tab === 'Cargo Insurance' ? '#1267CF' : '#616172',*/}
              {/*  }}*/}
              {/*  onClick={() => {*/}
              {/*    setTab('Cargo Insurance');*/}
              {/*    setTabValue(TAB.CARGO);*/}
              {/*  }}*/}
              {/*>*/}
              {/*  Cargo Insurance*/}
              {/*  <Count*/}
              {/*    style={{*/}
              {/*      color: tab === 'Cargo Insurance' ? '#0E71EB' : data && data?.cargo_limit ? '#0BAA1B' : '#616172',*/}
              {/*      backgroundColor:*/}
              {/*        tab === 'Cargo Insurance'*/}
              {/*          ? '#B0DCFF'*/}
              {/*          : data && data?.cargo_limit*/}
              {/*            ? 'rgba(11, 170, 27, 0.15)'*/}
              {/*            : '#e9eaf8',*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {data && data?.cargo_limit ? 'Done' : 'Pending'}*/}
              {/*  </Count>*/}
              {/*</Tab>*/}

              {/*<Tab*/}
              {/*  style={{*/}
              {/*    color: tab === 'W9' ? '#1267CF' : '#616172',*/}
              {/*  }}*/}
              {/*  onClick={() => {*/}
              {/*    setTab('W9');*/}
              {/*    setTabValue(TAB.W9);*/}
              {/*  }}*/}
              {/*>*/}
              {/*  W9*/}
              {/*  <Count*/}
              {/*    style={{*/}
              {/*      color: tab === 'W9' ? '#0E71EB' : data && data?.w9 ? '#0BAA1B' : '#616172',*/}
              {/*      backgroundColor:*/}
              {/*        tab === 'W9' ? '#B0DCFF' : data && data?.w9 ? 'rgba(11, 170, 27, 0.15)' : '#e9eaf8',*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {data && data?.w9 ? 'Done' : 'Pending'}*/}
              {/*  </Count>*/}
              {/*</Tab>*/}

              {/*<Tab*/}
              {/*  style={{*/}
              {/*    color: tab === 'USDOT certificate' ? '#1267CF' : '#616172',*/}
              {/*  }}*/}
              {/*  onClick={() => {*/}
              {/*    setTab('USDOT certificate');*/}
              {/*    setTabValue(TAB.USDOT);*/}
              {/*  }}*/}
              {/*>*/}
              {/*  USDOT certificate{' '}*/}
              {/*  <Count*/}
              {/*    style={{*/}
              {/*      color:*/}
              {/*        tab === 'USDOT certificate' ? '#0E71EB' : data && data?.usdot_certificate ? '#0BAA1B' : '#616172',*/}
              {/*      backgroundColor:*/}
              {/*        tab === 'USDOT certificate'*/}
              {/*          ? '#B0DCFF'*/}
              {/*          : data && data?.usdot_certificate*/}
              {/*            ? 'rgba(11, 170, 27, 0.15)'*/}
              {/*            : '#e9eaf8',*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {data && data?.usdot_certificate ? 'Done' : 'Pending'}*/}
              {/*  </Count>*/}
              {/*</Tab>*/}
            </TabPanel>
            <Line />
            <Item>
              {(() => {
                switch (tab) {
                  case 'Carrier information': {
                    return <CarrierInformation key="carrier" data={data} />;
                  }
                  case 'SuperDispatch Information': {
                    return <SuperDispatchInformation key="superDispatch" data={data} />;
                  }
                  case 'Penguin information': {
                    return <CarrierInformation key="penguin" data={penguinData} isPenguin={true} />;
                  }
                  case 'Cargo Insurance': {
                    return <CargoInsurance data={data} />;
                  }
                  case 'W9': {
                    return <W9 data={data} />;
                  }
                  case 'USDOT certificate': {
                    return <USDOT data={data} />;
                  }
                  default:
                    return null;
                }
              })()}
            </Item>
          </Block>
        </Wrapper>
      </SettingsContainer>
    </>
  );
};

export default CarrierProfile;
